import {Flex, Tag, Text} from '@ua/design-system'

const NewItem: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <Flex justify="space-between" alignItems="center">
      <Text as="span">{children}</Text>
      <Tag ml="3xs" variant="solidBlue" label="NEW" flexShrink={0} />
    </Flex>
  )
}

export default NewItem
